class FeelingDataSet extends TimelineListBase {
	constructor () {
		super();
    }
    addFeeling (feeling) {
		this.add(feeling, feeling.id, feeling.time);
    }
}